import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tooltip, InfoIcon, AsterixIcon } from 'components';

export const ReduxFormElementWrapper = (props) => {
  const {
    title,
    description,
    meta,
    // additional ClassNames
    fieldClassName,
    childClassName,
    titleClassName,
    descriptionClassName,
    // additional Styles
    errorBgStyle = {},
    //
    bottomErrorClassName,
    isBottomErrorDisplay,
    isBackgroundErrorDisplay,
    isColorErrorDisplay,
    isAsterixErrorDisplay,
    children,
    childrenMarginTop,
    lightDescription,
    tooltipFor,
    tooltipInfo,
    tooltipType,
    tooltipWidth,
    input,
    additionalRightPanelButton,
    // block wrapper props
    isBlockWrapper,
    isShowBlockError,
    bottomErrorText,
    testId,
  } = props;

  const shouldFieldErrorDisplay = meta.error && meta.touched;
  const shouldErrorDisplay = shouldFieldErrorDisplay || isShowBlockError;

  const childrenWithProps = React.Children.map(children, (child) =>
    isBlockWrapper ? child : React.cloneElement(child, { name: input.name }),
  );

  return (
    <div
      test-id={testId}
      className={classnames('form-fields-container', fieldClassName)}
    >
      {shouldErrorDisplay && (isBackgroundErrorDisplay || isBlockWrapper) && (
        <div style={{ ...errorBgStyle }} className="form-fields__error-bg" />
      )}

      <div className="form-fields__content">
        {title && (
          <div className="form-fields__header">
            <div className={classnames({ _error: shouldErrorDisplay })}>
              {shouldErrorDisplay && isAsterixErrorDisplay && (
                <AsterixIcon className="mr-1" />
              )}
              <span
                className={classnames('form-fields__title', titleClassName, {
                  _error: shouldErrorDisplay,
                })}
                dangerouslySetInnerHTML={{
                  __html: title
                    .replace(/<(\/)?script>/gi, '&lt;script&gt;')
                    .replace(
                      '(optional)',
                      '<span class="_optional">(optional)</span>',
                    )
                    .replace('(br)', '<br />'),
                }}
              />
            </div>
            <div className="form-fields__right-panel">
              {additionalRightPanelButton && (
                <div className="form-fields__right-panel-additional">
                  {additionalRightPanelButton}
                </div>
              )}
              {tooltipInfo && tooltipFor === 'title' && (
                <div className="form-fields__tooltip">
                  <Tooltip
                    width={tooltipWidth}
                    type={tooltipType}
                    info={tooltipInfo}
                  >
                    <InfoIcon width="17px" height="17px" />
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
        )}
        {description && (
          <div
            className={classnames('form-fields__description', {
              _light: lightDescription,
            })}
            style={{ marginTop: title ? '4px' : '0' }}
          >
            <div className={descriptionClassName}>{description}</div>
            {tooltipInfo && tooltipFor === 'description' && (
              <div className="form-fields__tooltip">
                <Tooltip
                  width={tooltipWidth}
                  type={tooltipType}
                  info={tooltipInfo}
                >
                  <InfoIcon width="17px" height="17px" />
                </Tooltip>
              </div>
            )}
          </div>
        )}

        <div
          className={classnames(
            'form-fields__children',
            {
              'input-component__with-error':
                isColorErrorDisplay && shouldFieldErrorDisplay,
            },
            childClassName,
          )}
          style={{ marginTop: title || description ? childrenMarginTop : '0' }}
        >
          {childrenWithProps}
        </div>
      </div>

      {shouldErrorDisplay && isBottomErrorDisplay && (
        <div
          test-id={`error-${input.name}`}
          className={classnames('form-fields__error', bottomErrorClassName)}
        >
          {meta.error}
        </div>
      )}
      {shouldErrorDisplay && bottomErrorText && (
        <div className="form-fields__error">{bottomErrorText}</div>
      )}
    </div>
  );
};

ReduxFormElementWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  title: PropTypes.string,
  meta: PropTypes.object,
  input: PropTypes.object,
  fieldClassName: PropTypes.string,
  childClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  errorBgStyle: PropTypes.object,
  bottomErrorClassName: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isBottomErrorDisplay: PropTypes.bool,
  isBackgroundErrorDisplay: PropTypes.bool,
  isColorErrorDisplay: PropTypes.bool,
  isAsterixErrorDisplay: PropTypes.bool,
  lightDescription: PropTypes.bool,
  childrenMarginTop: PropTypes.string,
  popoverInfo: PropTypes.string,
  tooltipFor: PropTypes.string,
  tooltipType: PropTypes.string,
  additionalRightPanelButton: PropTypes.node,
  // block wrapper props
  isBlockWrapper: PropTypes.bool,
  isShowBlockError: PropTypes.bool,
};

ReduxFormElementWrapper.defaultProps = {
  children: null,
  title: '',
  meta: {},
  input: {},
  fieldClassName: '',
  childClassName: '',
  titleClassName: '',
  descriptionClassName: '',
  errorBgStyle: {},
  bottomErrorClassName: '',
  description: '',
  isBottomErrorDisplay: true,
  isBackgroundErrorDisplay: false,
  isColorErrorDisplay: true,
  isAsterixErrorDisplay: true,
  lightDescription: false,
  childrenMarginTop: '0',
  popoverInfo: '',
  tooltipFor: 'title', // title, field, description
  tooltipType: 'bottom',
  additionalRightPanelButton: null,
  // block wrapper props
  isBlockWrapper: false,
  isShowBlockError: false,
};
